import './index.scss'
$("#nav5").addClass("active");
$(function () {
    $(window).scroll(function () {
        // 可是窗口滚动条发生滚动的时候 垂直方向滚动到多少距离的时候 让头部导航条设置上一个固定定位的样式
        if ($(window).scrollTop() >= ($("header").height())) {
            // alert($("#slideBox").height());
            $("header").addClass("head1");
        } else {
            $("header").removeClass("head1");
        }
    })
})
